require('./bootstrap.js');

require('../modernizr-webp.js');
// require('../jasny/jasny-bootstrap.js');
require('remodal');
require('../modules/remodal/mobile-fix');
require('../assign-general-functions-to-window.js');
import supportedBrowserNotification from '../core/supported-browser-notification';
const validBrowser = supportedBrowserNotification();

import ContactFormValidator from '../validation/ContactFormValidator';
import CustomerLocationHandler from '../modules/CustomerLocationHandler';
import GoogleMapsLoaderClass from '../modules/GoogleMapsLoader';
import LocationDataLoader from '../modules/LocationDataLoader';

// Global function to get the correct map pin icon depending on brand
import getMapIcon from '../modules/mapIcon';

import router from './routes.js';
import store from './store/index.js';

import getMetaDataFromRoute from './api/GetMetaDataFromRoute';

import Name from './components/Forms/Name.vue';
import Title from '../core/components/Forms/Title.vue';
import FirstName from '../core/components/Forms/FirstName.vue';
import LastName from '../core/components/Forms/LastName.vue';
import Email from '../core/components/Forms/Email.vue';
import Telephone from '../core/components/Forms/Telephone.vue';
import Dealer from '../core/components/Forms/Dealer.vue';
import CustomerLocation from '../used-vue/components/Forms/Non-Material/CustomerLocation.vue';
import Privacy from '../core/components/Forms/Privacy.vue';

import UsedCarAlertModal from './components/UsedCarAlertModal';
// import LiveChatButton from './components/Layout/LiveChatButton';
import RepresentativeExample from './components/Finance/RepresentativeExample';
import { getFromStorage } from './api/Storage.js';
import { customEvent, generateLeadEvent, trackPageView } from './../modules/tracking/AnalyticsEvents';
// Campaign:
// import CampaignForm from './components/Campaign/2018/Jan-Sale/Form';
// Vue.component('campaign-form', CampaignForm);

if (validBrowser) {
    window.LocationDataLoader = new LocationDataLoader;
    window.ContactFormValidator = ContactFormValidator;
    window.CustomerLocationHandler = CustomerLocationHandler;
    window.customerLat = getCookieValue('lat');
    window.customerLng = getCookieValue('lng');
    window.customerPostcode = getCookieValue('postcode');
    window.customerGeolocation = getCookieValue('geolocation');
    // Create a global object for getting a new Google Maps instance
    window.GoogleMapsLoader = new GoogleMapsLoaderClass;
    // Handle detecting when Google Maps has finished loading
    window.googleMapsLoaded = () => {
        GoogleMapsLoader.mapLoaded();
    };
    // require('../live-chat/live-chat');
    require('../cookie-warning.js');
    require('../modules/polyfills/string-padStart');

    Vue.mixin({
        methods: {
            gaTag(eventCategory = '', eventAction = '', eventLabel = '') {
                customEvent(eventCategory, eventAction, eventLabel, 0);
            },
            generateLeadEvent(name = 'Misc Event', value = 0, currency = 'GBP') {
                generateLeadEvent(name, currency, value);
            },
            trackPageView() {
                trackPageView();
            }
        }
    });


    Vue.component('customer-title', Title);
    Vue.component('customer-first-name', FirstName);
    Vue.component('customer-last-name', LastName);
    Vue.component('customer-name', Name);
    Vue.component('customer-email', Email);
    Vue.component('customer-location', CustomerLocation);
    Vue.component('customer-dealer', Dealer);
    Vue.component('customer-telephone', Telephone);
    Vue.component('customer-privacy', Privacy);

    Vue.component('used-car-alert-modal', UsedCarAlertModal);
    Vue.component('representative-example', RepresentativeExample);

    const bodyEl = document.body;
    const metaDescription = document.querySelector('meta[name="description"]');
    const titleEl = document.querySelector('title');
    const canonicalEl = document.querySelector('link[rel="canonical"]');
    let firstLoad = true;

    if (typeof window.preloadedLocationData !== 'undefined' && typeof window.preloadedLocationData.d !== 'undefined' && window.preloadedLocationData.d.length > 0) {
        store.commit('UsedSearchOptions/setUsedDealers', window.preloadedLocationData.d);
    } else {
        console.error('UsedDealer data missing');
    }

    router.afterEach((to, from) => {
        // Helper function to get meta data from the route. Some routes have the brand as a param in the URL
        // This helper function changes the "meta" data based on the brand if applicable
        const metaDataForRoute = getMetaDataFromRoute(to);
        store.commit('Layout/setShowSaveCompare', (to.name == 'saved-vehicles') ? false : true);
        if (metaDataForRoute.brand) {
            store.commit('Layout/setBrand', metaDataForRoute.brand);
        } else {
            store.commit('Layout/setBrand', 'randd');
        }

        if (typeof liveChatClass !== 'undefined' && to.meta.showMultiBrandLiveChat) {
            if (typeof to.meta.customerType !== 'undefined') {
                liveChatClass.setCustomerType(to.meta.customerType);
            }
            if (!from.meta.searchPage || !to.meta.searchPage) {
                liveChatClass.initLiveChat();
            }
        }

        // Update the page title
        if (store.getters['UsedSearchOptions/seoTitle'] != null) {
            titleEl.innerHTML = store.getters['UsedSearchOptions/seoTitle'];
        } else if (metaDataForRoute.title) {
            titleEl.innerHTML = metaDataForRoute.title;
        }

        // Update the meta description
        if (store.getters['UsedSearchOptions/seoDescription'] != null) {
            metaDescription.setAttribute('content', store.getters['UsedSearchOptions/seoDescription']);
        } else if (metaDataForRoute.desc) {
            metaDescription.setAttribute('content', metaDataForRoute.desc);
        }

        // Campaign
        // Reset the form back to not completed so the customer can fill in again
        // store.commit('CampaignStore/setCompleted', false);

        if (metaDataForRoute.searchPage) {
            store.commit('UsedSearchOptions/setLastResultsUrl', to);
        }

        canonicalEl.setAttribute('href', 'https://www.stellantisandyou.co.uk' + to.path);

        // Send Page View event
        if (firstLoad) {
            firstLoad = false;
        } else {
            trackPageView(location.pathname, titleEl.innerHTML);
        }

        let classes = [
            // store.state.Layout.brand,
        ];
        if (metaDataForRoute.bodyClasses) {
            for (let i = 0, len = metaDataForRoute.bodyClasses.length; i < len; i += 1) {
                classes.push(metaDataForRoute.bodyClasses[i]);
            }
        }
        let toRemove = [];
        // Remove classes that aren't listed in const classes
        for (let i = 0, len = bodyEl.classList.length; i < len; i += 1) {
            if (classes.indexOf(bodyEl.classList[i]) == -1) {
                toRemove.push(bodyEl.classList[i]);
            }
        }

        for (let i = 0, len = toRemove.length; i < len; i += 1) {
            bodyEl.classList.remove(toRemove[i]);
        }

        for (let i = 0, len = classes.length; i < len; i += 1) {
            bodyEl.classList.add(classes[i]);
        }

        Vue.nextTick(() => {
            if (window.reloadCMSContentSlices) {
                window.reloadCMSContentSlices();
            }
        });
    });

    router.beforeEach((to, from, next) => {
        store.dispatch('Dealers/initializeLocation').then(data => {
            // If we go from a dealer landing page which forces the location ID to a single value, to a non dealer landing page, call locationUpdated which will determine the nearest dealers again
            if (from.name == 'dealer-landing-page' && to.name !== 'dealer-landing-page') {
                store.dispatch('UsedSearchOptions/locationUpdated', false);
            }

            next();
        }).catch(error => {
            console.error('Dealers/initializeLocation error', error);
            next();
            return;
        });
    });

    // Vue.config.devtools = true

    const app = new Vue({
        el: '#app',
        data: {
            brand: 'randd',
        },
        store,
        router,
        created: function () {
            this.$store.dispatch('CustomerData/initialize');
            this.$store.dispatch('Layout/initialize');
            this.$store.dispatch('FinanceParameters/initialize');
            this.$store.dispatch('Valuations/initialize');
            this.$store.commit('UsedSearchOptions/setLandingPageData');
            this.$store.commit('UsedSearchOptions/setDealerLandingPageData');
            // Try to load the last results page the customer viewed from storage. This is used for the 'back to search' button on the more details page
            try {
                const lastResultsUrl = JSON.parse(getFromStorage('lastResultsUrl', false));
                if (lastResultsUrl !== false) {
                    this.$store.commit('UsedSearchOptions/setLastResultsUrl', lastResultsUrl);
                }
            } catch (error) {
                // Couldn't load last results URL
            }
        },
    });
    window.getMapIcon = getMapIcon;
}